import React, { Component } from "react";
import queryString from "query-string";

import { IMAGE } from "../constants/modelExportTypes";
import ModelExportPdf from "./ModelExportPdf";
import ModelExportImage from "./ModelExportImage";

class ModelExport extends Component {
  componentDidMount() {
    this.props.hideHeader();
  }

  render() {
    if (!this.props.modelExport || !this.props.location) {
      return null;
    }

    const { type } = queryString.parse(this.props.location.search);
    const ModelExportComp = type === IMAGE ? ModelExportImage : ModelExportPdf;

    return (
      <ModelExportComp t={this.props.t} modelExport={this.props.modelExport} />
    )
  }
};

export default ModelExport;



// WEBPACK FOOTER //
// ./src/components/ModelExport.js